import { IContainer, injectContainer } from './container';

export type ProgressNotifier = (progress: number) => void;

export interface IProgressPromise<ValueType> extends Promise<ValueType> {
    readonly progress: number;
    onProgress(callback: ProgressNotifier): void;
}

export type PromiseExecutor<ValueType> = (
    resolve: (value?: ValueType | PromiseLike<ValueType>) => void,
    reject: (reason?: unknown) => void,
    progress: ProgressNotifier,
) => void;

export interface IProgressPromiseGenerator {
    promise: <ValueType>(executor: PromiseExecutor<ValueType>) => IProgressPromise<ValueType>;
}

const TYPES = {
    IProgressPromiseGenerator: Symbol.for('IProgressPromiseGenerator'),
};

export function injectProgressPromise(
    container: IContainer = injectContainer(),
): IProgressPromiseGenerator {
    return container.get<IProgressPromiseGenerator>(TYPES.IProgressPromiseGenerator);
}

export function bindProgressPromise(
    val: IProgressPromiseGenerator,
    container: IContainer = injectContainer(),
) {
    return container.bind<IProgressPromiseGenerator>(TYPES.IProgressPromiseGenerator, val);
}
